import React, { useEffect, useRef, useState } from "react";
import { IComment } from "@Types/articles";
import { fetchCommentList } from "../../services/article";
import { ICommentComponentsProps } from "./types";
import WriteComment from "./WriteComment";
import CommentItem from "./CommentItem";
import styles from "./comment.module.less";
import { useMutation, useQuery } from "react-query";
import { fetchPaging } from "@Services/api";
import { ECommentType } from "@Types/constants";
/**
 * 业务组件 评论组件
 * @param
 */

const CommentComp: React.FC<ICommentComponentsProps> = (props: ICommentComponentsProps) => {
  const { type, id, isSign, emptyConetent } = props;
  const sectionRef = useRef(null);

  const [items, setItems] = useState([]);

  const [paging, setPaging] = useState("");
  const [total, setTotal] = useState(0);

  const initData = {};
  const { refetch } = useQuery<any>([`fetchCommentList`, id, type], async () => {
    const res = await fetchCommentList({ id, type: ECommentType.MENU, limit: 3 });

    if (res?.status === 12000) {
      setTotal(res.data.total);
      setItems([...res.data.list]);
      setPaging(res.data.paging);
    }
    return res?.status === 12000 ? res.data : initData;
  });

  const mutation = useMutation<void, unknown, unknown>(async (params) => {
    const res = await fetchPaging(paging);
    if (res?.status === 12000) {
      setPaging(res.data.paging);
      setItems([...items, ...res.data.list]);
    }
  });

  return (
    <section className={styles["IframeCommentList"]} ref={sectionRef}>
      <div className={"flex justify-between items-center h-36 relative"}>
        <h3 className={`text-20 font-[400]`}>發佈我的評論</h3>
      </div>
      <WriteComment
        placeholder={total === 0 ? "快來發佈第一條評論吧" : "快來發佈評論吧"}
        id={id}
        type={ECommentType.MENU}
        isSign={isSign}
        response={refetch}
      />

      <div className={styles["comment-seciton"]}>
        {/* {items?.length > 0 && <h3 className={`${styles["title"]} font-semibold`}>最新評論</h3>} */}
        {items?.length > 0 &&
          items.map((item: any, index: number) => (
            <CommentItem id={id} type={ECommentType.MENU} data={item} key={index} isSign={isSign} response={refetch} />
          ))}
        {!!paging && (
          <div
            className='mx-auto text-16 text-[#666] w-380 h-40 flex items-center justify-center bg-[#F5F5F5] mb-20 mt-14 cursor-pointer'
            onClick={() => {
              mutation.mutate(paging);
            }}
          >
            更多菜單評論
          </div>
        )}
        {items?.length > 3 && !paging && (
          <div
            className='mx-auto text-16 text-[#666] w-380 h-40 flex items-center justify-center bg-[#F5F5F5] mb-20 mt-14 cursor-pointer'
            onClick={() => {
              refetch();
            }}
          >
            收起菜單評論
          </div>
        )}
      </div>
    </section>
  );
};

export default CommentComp;
